import { render, staticRenderFns } from "./SavedViewsListRow.vue?vue&type=template&id=64d4f310&scoped=true"
import script from "./SavedViewsListRow.vue?vue&type=script&lang=js"
export * from "./SavedViewsListRow.vue?vue&type=script&lang=js"
import style0 from "./SavedViewsListRow.vue?vue&type=style&index=0&id=64d4f310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4f310",
  null
  
)

export default component.exports